import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link, useNavigate } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useAuth } from '../context/AuthContext';

import { Route, Routes } from 'react-router';
import { pages, adminPages, viewerPages } from '../configuration/Pages';
import { ViewerRoute } from './ViewerRoute';
import axios from 'axios';
import NewTender from './NewTender';
import AdvanceTender from './AdvanceTender';
import Import from './Import';
import Analytics from './Analytics';
import Export from './Export';
import TenderOverview from './TenderOverview';
import Admin from './Admin';
import Login from './Login';
import Logout from './Logout';
import Departments from './Pages/Departments';
import DepartmentDeactivated from './DepartmentDeactivated';

import { API_BASE_URL } from '../configuration/Configuration';
const linkStyle = {
  textDecoration: 'none',
  color: 'black',
};

const headerLinkStyle = {
  textDecoration: 'none',
  color: 'white',
  padding: '0',
  margin: '0',
};

const drawerWidth = 240;

function ResponsiveDrawer() {
  const { isAuth, user, userType, logout } = useAuth();

  const navigate = useNavigate();

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      {isAuth && userType?.isViewer && (
        <List>
          {viewerPages.map((page) => (
            <ListItem key={page.name} disablePadding>
              <ListItemButton
                sx={{ width: drawerWidth }}
                selected={
                  window.location.pathname === page.path ||
                  (window.location.pathname === '/' &&
                    page.path === '/AdvanceTender')
                }
                onClick={() => {
                  navigate(page.path, { state: { id: 'reload' } });
                }}
              >
                <ListItemIcon>{page.icon}</ListItemIcon>
                <ListItemText primary={page.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
      {isAuth && !userType?.isViewer && (userType?.departmentStatus !== 'deleted' || userType?.hasActiveDepartments) && (
        <List>
          {pages.map((pages) => (
            <ListItem key={pages.name} disablePadding>
              <ListItemButton
                sx={{ width: drawerWidth }}
                selected={
                  window.location.pathname === pages.path ||
                  (window.location.pathname === '/' &&
                    pages.path === '/AdvanceTender')
                }
                onClick={() => {
                  navigate(pages.path, { state: { id: 'reload' } });
                }}
              >
                <ListItemIcon>{pages.icon}</ListItemIcon>
                <ListItemText primary={pages.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
      {userType && userType.isAdmin && !userType?.isViewer && <Divider />}
      {userType && userType.isAdmin && !userType?.isViewer && (
        <List>
          {adminPages.map((pages) => (
            <ListItem key={pages.name} disablePadding>
              <ListItemButton
                sx={{ width: drawerWidth }}
                selected={window.location.pathname === pages.path}
                onClick={() => {
                  navigate(pages.path);
                }}
              >
                <ListItemIcon>{pages.icon}</ListItemIcon>
                <ListItemText primary={pages.name} />
              </ListItemButton>
              {/* </Link> */}
            </ListItem>
          ))}
        </List>
      )}
      {isAuth ? <Divider /> : null}
      {!isAuth ? (
        <List>
          {['Login'].map((text, index) => (
            <ListItem key={text} disablePadding>
              <Link to={`/login`} style={linkStyle}>
                <ListItemButton sx={{ width: drawerWidth }}>
                  <ListItemIcon>
                    <LoginIcon />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </Link>
            </ListItem>
          ))}
        </List>
      ) : (
        <List>
          {['Logout'].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton
                sx={{ width: drawerWidth }}
                onClick={async () => {
                  try {
                    const result = await logout();
                    if (result.success) {
                      navigate('/login');
                    }
                  } catch (error) {
                    console.error('Logout failed', error);
                    navigate('/login');
                  }
                }}
              >
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </div>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: '#a2232b' }}
      >
        <Toolbar style={{ padding: '0', margin: '0' }}>
          <Link to={`/`} style={{ margin: '0', padding: '0' }}>
            <div style={{ width: drawerWidth }}>
              <img
                src="/logosvg.svg"
                height="70"
                className="queLogo"
                alt="Logo Quehenberg"
              />
            </div>
          </Link>

          <Link to={`/`} style={headerLinkStyle}>
            <Typography variant="h6" noWrap component="div">
              Tender Management Tool
            </Typography>
          </Link>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            {' '}
          </Typography>
          {isAuth && <AccountCircleIcon />}
          <div style={{ width: '10px' }}></div>
          {isAuth && (
            <Typography variant="h6" noWrap component="div">
              {user}
            </Typography>
          )}
          <div style={{ width: '10px' }}></div>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
          }}
          open
        >
          {drawer}
          <List className="bottomPush"></List>
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Toolbar />
        {/* TODO add Routing here */}
        <Routes>
          {!isAuth && <Route path="/" element={<Login />} />}
          {isAuth && userType?.departmentStatus === 'deleted' && userType?.isStaff && !userType?.hasActiveDepartments && (
            <>
              <Route path="/" element={<DepartmentDeactivated />} />
              <Route path="/AdvanceTender" element={<DepartmentDeactivated />} />
              <Route path="/NewTender" element={<DepartmentDeactivated />} />
              <Route path="/Import" element={<DepartmentDeactivated />} />
              <Route path="/Export" element={<DepartmentDeactivated />} />
              <Route path="/TenderOverview" element={<DepartmentDeactivated />} />
              <Route path="/departments" element={<DepartmentDeactivated />} />
            </>
          )}
          {isAuth && (userType?.departmentStatus !== 'deleted' || userType?.hasActiveDepartments) && <Route path="/" element={<AdvanceTender />} />}
          <Route path="NewTender" element={<ViewerRoute>{isAuth && (userType?.departmentStatus !== 'deleted' || userType?.hasActiveDepartments) && <NewTender />}</ViewerRoute>} />
          <Route path="Import" element={<ViewerRoute>{isAuth && (userType?.departmentStatus !== 'deleted' || userType?.hasActiveDepartments) && <Import />}</ViewerRoute>} />
          <Route path="AdvanceTender" element={isAuth && (userType?.departmentStatus !== 'deleted' || userType?.hasActiveDepartments) && <AdvanceTender isViewer={userType?.isViewer ?? false} />} />
          <Route path="Export" element={<ViewerRoute>{isAuth && (userType?.departmentStatus !== 'deleted' || userType?.hasActiveDepartments) && <Export />}</ViewerRoute>} />
          <Route path="TenderOverview" element={isAuth && (userType?.departmentStatus !== 'deleted' || userType?.hasActiveDepartments) && <TenderOverview />} />
          <Route
            path="Admin"
            element={<ViewerRoute>{userType && userType.isAdmin && <Admin />}</ViewerRoute>}
          />
          <Route
            path="Analytics"
            element={<ViewerRoute>{userType && userType.isAdmin && <Analytics />}</ViewerRoute>}
          />

          <Route
            path="departments"
            element={<ViewerRoute>{isAuth && (userType?.departmentStatus !== 'deleted' || userType?.hasActiveDepartments) && <Departments userType={userType || {}} />}</ViewerRoute>}
          />

          <Route path="Logout" element={<Logout />} />
        </Routes>
      </Box>
    </Box>
  );
}

export default ResponsiveDrawer;
